<template>
  <div class="ui centered grid">
        <div class="sixteen wide column ">
            <form class="ui form" style="padding:30px;" id="asdvanced_search_form" method="post">
                <div class="ui small form">
                    <div class="field">
                        <input type="text" name="search" placeholder="Search..." style="border: 2px solid darkgray">
                    </div>
                    <div class="ui accordion" id="advanced_form_accordion">
                        <div class="title">
                            <i class="dropdown icon"></i>
                            Advanced Search<br><br>
                        </div>
                        <div class="content">
                            <!-- <div class="two fields">-->
                            <div class="field">
                                <label>Inventory (OR)</label>
                                <select class="ui fluid search dropdown" multiple="" id="inventory" name="inventory">
                                    <option value="">Select Inventory...</option>
                                    <option v-for="inventory in inventories" :key="inventory.name" v-bind:value="inventory.name">{{inventory.label}}</option>
                                </select>
                            </div><br>
                            <!--   <div class="field">
                                 <label>Rooms (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="room" name="room">
                                        <option value="">Room...</option>
                                        <option v-for="room in rooms" :key="room.id" v-bind:value="room.id">{{room.id}} – {{room.label}}</option>
                                    </select>
                                </div>--><br>
                            <!-- </div>-->
                            <div class="two fields">
                                <div class="field">
                                    <label>Rooms (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="room" name="room">
                                        <option value="">Room...</option>
                                        <option v-for="room in rooms" :key="room.id" v-bind:value="room.id">{{room.id}} – {{room.label}}</option>
                                    </select>
                                </div><br>
                                <div class="field" id="places_field" style="display:none">
                                    <label>Place (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="place" name="place">
                                        <option value="">Place..</option>
                                        <option v-for="place in places" :key="place.id" v-bind:value="place.id">{{place.id}} – {{place.label}}</option>
                                    </select>
                                </div><br>
                            </div>
                            <div class="fields">
                                <div class="eight wide field">
                                    <label>Artist/Copist (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="persname" name="persname">
                                        <option value="">Artist/Copist</option>
                                        <option v-for="name in persnames" :key="name.getty_id" class="item" v-bind:value="((name.hasOwnProperty('getty_id')) ? name.getty_id : name.display_name)">
                                            <img v-if="name.hasOwnProperty('getty_id')" src="/static/getty-logo.png" style="width:20px!important;height:20px!important;margin:-4px 4px 2px -4px;">
                                            {{name.display_name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="six wide field">
                                    <label>Artist´s Origin (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="nationality" name="nationality">
                                        <option value="">Nationality...</option>
                                        <option v-for="nationality in nationalities" :key="nationality" v-bind:value="nationality">{{nationality}}</option>
                                    </select>
                                </div>
                                <div class="two wide field">
                                    <label>School of Prague</label>
                                    <div class="ui toggle checkbox " style="margin-right:1em;">
                                        <input type="checkbox" name="shool_of_prague">
                                    </div>
                                </div>
                            </div>
                            <div class="field">
                                <label>Subject (AND)</label>
                                <select class="ui fluid search dropdown" multiple="" id="subject" name="subject">
                                    <option value="">Keywords...</option>
                                    <!--  <option v-for="word in iconclasskw" :key="word" v-bind:value="word">{{word}}(<i class="sign-in icon"></i>)</option>-->
                                    <option v-for="word in subject" :key="word" v-bind:value="word">{{word}}</option>
                                </select>
                            </div><br>
                            <div class="three fields">
                                <div class="field">
                                    <label>Technique (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="technique" name="technique">
                                        <option value="">Technique...</option>
                                        <option v-for="technique in techniques" :key="technique" v-bind:value="technique">{{technique}}</option>
                                    </select>
                                </div>
                                <div class="field">
                                    <label>Original / Copy according the Inventory</label>
                                    <div class="ui toggle checkbox " style="margin-right:1em;">
                                        <input type="checkbox" name="original">
                                        <label style="padding-left:4em">Original</label>
                                    </div>
                                    <div class="ui toggle checkbox " style="margin-right:1em;">
                                        <input type="checkbox" name="copy">
                                        <label style="padding-left:4em">Copy</label>
                                    </div>
                                </div>
                                <div class="field">
                                    <label>Quality according the Inventory</label>
                                    <div class="ui toggle checkbox " style="margin-right:1em;">
                                        <input type="checkbox" name="quality_low">
                                        <label style="padding-left:4em">Low</label>
                                    </div>
                                    <div class="ui toggle checkbox " style="margin-right:1em;">
                                        <input type="checkbox" name="quality_high">
                                        <label style="padding-left:4em">High</label>
                                    </div>
                                </div>
                            </div><br>
                            <div class="field">
                                <label>Identified Object</label>
                                <div class="ui toggle checkbox " style="margin-right:1em;">
                                    <input type="checkbox" name="identified_art">
                                </div>
                            </div>
                            <div class="three fields">
                                <div class="field">
                                    <label>Institution (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="institution" name="institution">
                                        <option value="">Institution...</option>
                                        <option v-for="institution in institutions" :key="institution" v-bind:value="institution">{{institution}}</option>
                                    </select>
                                </div>
                                <div class="field">
                                    <label>City (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="city" name="city">
                                        <option value="">City...</option>
                                        <option v-for="city in cities" :key="city" v-bind:value="city">{{city}}</option>
                                    </select>
                                </div>
                                <div class="field">
                                    <label>Country (OR)</label>
                                    <select class="ui fluid search dropdown" multiple="" id="country" name="country">
                                        <option value="">Country...</option>
                                        <option v-for="country in countries" :key="country" v-bind:value="country">{{country}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button class="ui primary blue right floated button">Search</button>
                <div class="ui basic reset right floated  button">Reset</div>


            </form>

            <br><br>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['advanced'],
        data() {
            return {
                inventories: null,
                persnames: null,
                nationalities: null,
                //   iconclasskw: null,
                subject: null,
                rooms: null,
                places: null,
                techniques: null,
                institutions: null,
                cities: null,
                countries: null
            }
        },
        methods: {
            resetForm: function() {

            },
            cancel: function() {

            },
            getInventories: function() {

                axios
                    .get('/api/inventories')
                    .then(response => {
                        this.inventories = response.data;
                        $("#inventory").dropdown();
                        this.populateFormField('inventory', this.$route.query);
                    })
            },
            getPersNemes: function() {
                axios
                    .get('/api/name/all')
                    .then(response => {
                        this.persnames = response.data
                        $("#persname").dropdown({ fullTextSearch: true });
                        this.populateFormField('persname', this.$route.query);
                    })
            },
            getNationalies: function() {
                axios
                    .get('/api/form/nationality')
                    .then(response => {
                        this.nationalities = response.data.sort();;
                        $("#nationality").dropdown({ fullTextSearch: true });
                        this.populateFormField('nationality', this.$route.query);
                    })
            },
            getSubject: function() {
                axios
                    .get('/api/subject')
                    .then(response => {
                        this.subject = response.data;
                        $("#subject").dropdown({ fullTextSearch: true })
                        this.populateFormField('subject', this.$route.query);
                    })

            },
            getTechnique: function() {
                axios
                    .get('/api/form/technique')
                    .then(response => {
                        this.techniques = response.data.sort();;
                        $("#technique").dropdown({ fullTextSearch: true })
                        this.populateFormField('technique', this.$route.query);
                    })
            },
            getInstitution: function() {
                axios
                    .get('/api/form/institution')
                    .then(response => {
                        this.institutions = response.data.sort();;
                        $("#institution").dropdown({ fullTextSearch: true })
                        this.populateFormField('institution', this.$route.query);
                    })
            },
            getCity: function() {
                axios
                    .get('/api/form/city')
                    .then(response => {
                        this.cities = response.data.sort();;
                        $("#city").dropdown({ fullTextSearch: true })
                        this.populateFormField('city', this.$route.query);
                    })
            },
            getCountry: function() {
                axios
                    .get('/api/form/country')
                    .then(response => {
                        this.countries = response.data.sort();
                        $("#country").dropdown({ fullTextSearch: true })
                        this.populateFormField('country', this.$route.query);
                    })
            },

           getRooms: function() {
                var localThis = this
                axios
                    .get('/api/plan/list')
                    .then(response => {
                        this.rooms = response.data;
                        $("#room").dropdown({
                            fullTextSearch: true,
                            onChange: function() {
                                localThis.updatePlaces(($("#room").val()));
                            }
                        });
                        // 
                        this.populateFormField('room', this.$route.query);
                        this.populateFormField('place', this.$route.query);
                    })
            },
            
          /*   getRooms: function() {
                var localThis = this
                axios
                    .get('/api/rooms')
                    .then(response => {
                        this.rooms = response.data;
                        $("#room").dropdown({
                            fullTextSearch: true,
                            onChange: function() {
                                localThis.updatePlaces(($("#room").val()));
                            }
                        });
                        // 
                        this.populateFormField('room', this.$route.query);
                        this.populateFormField('place', this.$route.query);
                    })
            },*/
            serialize2JSON: function(a) {
                var o = {};
                //var a = this.serializeArray();
                $.each(a, function() {
                    if (o[this.name]) {
                        if (!o[this.name].push) {
                            o[this.name] = [o[this.name]];
                        }
                        o[this.name].push(this.value || '');
                    }
                    else {
                        o[this.name] = this.value || '';
                    }
                });
                return o;
            },

            populateFormField: function(field_name, query) {
                if (!jQuery.isEmptyObject(query) && query.hasOwnProperty(field_name)) {
                    setTimeout(function() {
                        var field = $('[name=' + field_name + ']', '#asdvanced_search_form');
                        if (field.attr('type') == "text") {
                            field.val(query[field_name]);
                        }
                        if (field.prop("tagName") == "SELECT") {
                            if (Array.isArray(query[field_name])) {
                                $.each(query[field_name], function(i, value) {
                                    $('#asdvanced_search_form').form('set value', field_name, value);
                                });
                            }
                            else {
                                $('#asdvanced_search_form').form('set value', field_name, query[field_name]);
                            }
                        }
                        if (field.attr('type') == "checkbox") {
                            field.prop("checked", ((query[field_name] == 'on') ? true : false));
                        }

                    }, 100);
                }
            },

            updatePlaces: function(selected_rooms) {
                if (selected_rooms.length > 0) {
                    var places = [];
                    for (var i in this.rooms) {
                        for (var j in selected_rooms) {
                            if (this.rooms[i].id == selected_rooms[j] && this.rooms[i].hasOwnProperty('places')) {
                                places = places.concat(this.rooms[i].places)
                                places = Array.from(new Set(places.map(a => a.id)))
                                    .map(id => {
                                        return places.find(a => a.id === id)
                                    })

                            }
                        }
                    }
                    if (places.length > 0) {

                        this.places = places;
                        $("#places_field").css("display", "block");
                        $("#place").dropdown({ fullTextSearch: true });
                    }

                }
                else {
                    this.places = null;
                    $("#places_field").css("display", "none");
                }
            },

           

        },

        watch: {

        },
        mounted() {
            this.getInventories();
            this.getPersNemes();
            this.getNationalies();
            //  this.getIconClassKW();
            this.getSubject();
            this.getRooms();
            this.getTechnique();
            this.getCity();
            this.getCountry();
            this.getInstitution();

            $('.ui.checkbox')
                .checkbox();
            var myThis = this;
            var fields = {
                username: 'empty',
                role: 'empty',
                first_name: 'empty',
                last_name: 'empty',
                email: 'email',
            }
            if (this.blank) {
                fields.password = ['minLength[6]', 'empty'];
            }
            if (this.settings) {
                // fields.password = ['minLength[6]', 'empty'];
                fields.confirm_password = 'match[password]';
            }
            setTimeout(function() {
                if (myThis.advanced) {
                    $('#advanced_form_accordion').accordion('open', 0);
                }
                else {
                    $('#advanced_form_accordion').accordion();
                }
                $('#asdvanced_search_form').form({
                    on: 'blur',
                    fields: fields,
                    onSuccess: function(event, fields) {
                        event.preventDefault();
                        var sqjson = myThis.serialize2JSON($('#asdvanced_search_form').serializeArray());
                        myThis.$emit('query', sqjson);
                       
                    }
                });
                if (!jQuery.isEmptyObject(myThis.$route.query)) {
                    myThis.populateFormField('search', myThis.$route.query);
                    myThis.populateFormField('original', myThis.$route.query);
                    myThis.populateFormField('copy', myThis.$route.query);
                    myThis.populateFormField('quality_high', myThis.$route.query);
                    myThis.populateFormField('quality_low', myThis.$route.query)
                    myThis.populateFormField('identified_art', myThis.$route.query);
                }
            }, 100);;

        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .colorSq {
        width: 100%;
        height: 100%;
        background-color: lightblue;
    }

    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px white inset !important;
    }

    /* DivTable.com */

    .divTable {
        display: table;


    }

    .divTableRow {
        display: table-row;

    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
    }

    .divTableCell,
    .divTableHead {
        border: 0px solid #999999;
        display: table-cell;
        padding: 15px 20px 15px 0px;
    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
        font-weight: bold;
    }

    .divTableFoot {
        background-color: #EEE;
        display: table-footer-group;
        font-weight: bold;
    }

    .divTableBody {
        display: table-row-group;
    }

    .displayNone {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheSearchForm.vue